import * as Types from '../../../types/graphql.generated';

import { gql } from '@apollo/client';
export type EventFragment = { __typename?: 'Event', id: string, name: string, description?: string | null, fullDay?: boolean | null, start?: string | null, end?: string | null, status?: Types.StatusTypes | null, locale: string, createdAt: string, updatedAt: string, image?: { __typename?: 'Media', id: string, name: string, locale: string, altText?: string | null, caption?: string | null, originalUrl: string, type: Types.MediaType, mimetype: string, createdAt: string, updatedAt: string, formats: { __typename?: 'Formats', xs: { __typename?: 'MediaFormat', url: string, width: number }, s: { __typename?: 'MediaFormat', url: string, width: number }, m: { __typename?: 'MediaFormat', url: string, width: number }, l: { __typename?: 'MediaFormat', url: string, width: number }, xl: { __typename?: 'MediaFormat', url: string, width: number } } } | null, place?: { __typename?: 'Place', id: string, name: string, status: Types.StatusTypes, locale: string, description?: string | null, createdAt: string, updatedAt: string, image?: { __typename?: 'Media', id: string, name: string, locale: string, altText?: string | null, caption?: string | null, originalUrl: string, type: Types.MediaType, mimetype: string, createdAt: string, updatedAt: string, formats: { __typename?: 'Formats', xs: { __typename?: 'MediaFormat', url: string, width: number }, s: { __typename?: 'MediaFormat', url: string, width: number }, m: { __typename?: 'MediaFormat', url: string, width: number }, l: { __typename?: 'MediaFormat', url: string, width: number }, xl: { __typename?: 'MediaFormat', url: string, width: number } } } | null, coordinates?: { __typename?: 'Coordinate', lat?: number | null, lng?: number | null, name?: string | null } | null } | null, artist?: { __typename?: 'Artist', id: string, name: string, status: Types.StatusTypes, locale: string, description?: string | null, createdAt: string, updatedAt: string, image?: { __typename?: 'Media', id: string, name: string, locale: string, altText?: string | null, caption?: string | null, originalUrl: string, type: Types.MediaType, mimetype: string, createdAt: string, updatedAt: string, formats: { __typename?: 'Formats', xs: { __typename?: 'MediaFormat', url: string, width: number }, s: { __typename?: 'MediaFormat', url: string, width: number }, m: { __typename?: 'MediaFormat', url: string, width: number }, l: { __typename?: 'MediaFormat', url: string, width: number }, xl: { __typename?: 'MediaFormat', url: string, width: number } } } | null } | null, mainEvent?: { __typename?: 'MainEvent', id: string, name: string, status: Types.StatusTypes, locale: string, description?: string | null, createdAt: string, updatedAt: string } | null, location?: { __typename?: 'Location', name?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null, email?: string | null, website?: string | null, information?: string | null } | null, coordinates?: { __typename?: 'CoordinateOptional', lat?: number | null, lng?: number | null, name?: string | null } | null, form?: { __typename?: 'Form', id: string, name: string, status: Types.StatusTypes, locale: string, description: string, content: string, createdAt: string, updatedAt: string } | null };

export const EventFragmentDoc = gql`
    fragment event on Event {
  id
  name
  description
  image {
    id
    name
    locale
    altText
    caption
    originalUrl
    type
    mimetype
    formats {
      xs {
        url
        width
      }
      s {
        url
        width
      }
      m {
        url
        width
      }
      l {
        url
        width
      }
      xl {
        url
        width
      }
    }
    createdAt
    updatedAt
  }
  place {
    id
    name
    image {
      id
      name
      locale
      altText
      caption
      originalUrl
      type
      mimetype
      formats {
        xs {
          url
          width
        }
        s {
          url
          width
        }
        m {
          url
          width
        }
        l {
          url
          width
        }
        xl {
          url
          width
        }
      }
      createdAt
      updatedAt
    }
    status
    locale
    coordinates {
      lat
      lng
      name
    }
    description
    createdAt
    updatedAt
  }
  artist {
    id
    name
    image {
      id
      name
      locale
      altText
      caption
      originalUrl
      type
      mimetype
      formats {
        xs {
          url
          width
        }
        s {
          url
          width
        }
        m {
          url
          width
        }
        l {
          url
          width
        }
        xl {
          url
          width
        }
      }
      createdAt
      updatedAt
    }
    status
    locale
    description
    createdAt
    updatedAt
  }
  fullDay
  start
  end
  mainEvent {
    id
    name
    status
    locale
    description
    createdAt
    updatedAt
  }
  location {
    name
    street
    postalCode
    city
    phone
    email
    website
    information
  }
  coordinates {
    lat
    lng
    name
  }
  form {
    id
    name
    status
    locale
    description
    content
    createdAt
    updatedAt
  }
  status
  locale
  createdAt
  updatedAt
}
    `;